import React from 'react';

import CodeGeneratorPage from '../components/CodeGeneratorPage';

const CodeGeneratorContainer = (props: any) => {
  return <CodeGeneratorPage  />;
};

export default CodeGeneratorContainer;
